var exports = {
  "SA": "VoiceConnectionStatus.module__voiceConnectionContainer___S1JBRm",
  "jf": "VoiceConnectionStatus.module__statusRow___S1JBRm",
  "Tm": "VoiceConnectionStatus.module__channelAvatarStack___S1JBRm",
  "kR": "VoiceConnectionStatus.module__signalIcon___S1JBRm",
  "rI": "VoiceConnectionStatus.module__statusButton___S1JBRm",
  "QQ": "VoiceConnectionStatus.module__statusConnected___S1JBRm",
  "Rg": "VoiceConnectionStatus.module__statusConnecting___S1JBRm",
  "iA": "VoiceConnectionStatus.module__statusDisconnected___S1JBRm",
  "ne": "VoiceConnectionStatus.module__controls___S1JBRm",
  "uH": "VoiceConnectionStatus.module__controlButton___S1JBRm",
  "wH": "VoiceConnectionStatus.module__selected___S1JBRm",
  "Kk": "VoiceConnectionStatus.module__icon___S1JBRm",
  "Hd": "VoiceConnectionStatus.module__connectionInfo___S1JBRm",
  "J3": "VoiceConnectionStatus.module__channelSourceRow___S1JBRm",
  "Dt": "VoiceConnectionStatus.module__channelSourceLink___S1JBRm",
  "_R": "VoiceConnectionStatus.module__channelSourceText___S1JBRm",
  "wl": "VoiceConnectionStatus.module__channelSourceChannel___S1JBRm",
  "EF": "VoiceConnectionStatus.module__channelSourceSeparator___S1JBRm",
  "_u": "VoiceConnectionStatus.module__channelSourceGuild___S1JBRm",
  "wt": "VoiceConnectionStatus.module__connectionIdRow___S1JBRm",
  "TR": "VoiceConnectionStatus.module__connectionIdValue___S1JBRm",
  "Gh": "VoiceConnectionStatus.module__connectionIdValueText___S1JBRm",
  "Hz": "VoiceConnectionStatus.module__connectionIdIcon___S1JBRm",
  "EU": "VoiceConnectionStatus.module__mediaSection___S1JBRm",
  "LA": "VoiceConnectionStatus.module__mediaButton___S1JBRm",
  "A1": "VoiceConnectionStatus.module__cameraActive___S1JBRm",
  "Cb": "VoiceConnectionStatus.module__screenShareActive___S1JBRm",
  "cU": "VoiceConnectionStatus.module__mediaIcon___S1JBRm",
  "jC": "VoiceConnectionStatus.module__popoutContainer___S1JBRm",
  "oO": "VoiceConnectionStatus.module__popoutBodyScroller___S1JBRm",
  "$V": "VoiceConnectionStatus.module__popoutBodyContent___S1JBRm",
  "hY": "VoiceConnectionStatus.module__popoutHeader___S1JBRm",
  "Gb": "VoiceConnectionStatus.module__popoutTitle___S1JBRm",
  "IZ": "VoiceConnectionStatus.module__popoutCloseButton___S1JBRm",
  "nO": "VoiceConnectionStatus.module__popoutStats___S1JBRm",
  "u$": "VoiceConnectionStatus.module__popoutStatsSection___S1JBRm",
  "yk": "VoiceConnectionStatus.module__popoutStatsSectionTitle___S1JBRm",
  "r6": "VoiceConnectionStatus.module__popoutStatsSectionRows___S1JBRm",
  "m1": "VoiceConnectionStatus.module__detailedStatsAccordion___S1JBRm",
  "G8": "VoiceConnectionStatus.module__detailedStatsButton___S1JBRm",
  "X6": "VoiceConnectionStatus.module__detailedStatsButtonText___S1JBRm",
  "VV": "VoiceConnectionStatus.module__detailedStatsCaret___S1JBRm",
  "hM": "VoiceConnectionStatus.module__detailedStatsContent___S1JBRm",
  "cl": "VoiceConnectionStatus.module__detailedStatsInner___S1JBRm",
  "gm": "VoiceConnectionStatus.module__popoutStatRow___S1JBRm",
  "Ub": "VoiceConnectionStatus.module__popoutStatLabel___S1JBRm",
  "Fz": "VoiceConnectionStatus.module__popoutStatValue___S1JBRm",
  "ep": "VoiceConnectionStatus.module__popoutStatTextValue___S1JBRm",
  "mp": "VoiceConnectionStatus.module__deviceBadge___S1JBRm",
  "Vs": "VoiceConnectionStatus.module__deviceBadgeText___S1JBRm",
  "hn": "VoiceConnectionStatus.module__endpointBadge___S1JBRm",
  "iu": "VoiceConnectionStatus.module__endpointBadgeText___S1JBRm",
  "_v": "VoiceConnectionStatus.module__chartContainer___S1JBRm",
  "nS": "VoiceConnectionStatus.module__chartSvg___S1JBRm",
  "$s": "VoiceConnectionStatus.module__gridLine___S1JBRm",
  "rK": "VoiceConnectionStatus.module__gridLineHorizontal___S1JBRm",
  "eB": "VoiceConnectionStatus.module__gridText___S1JBRm",
  "BC": "VoiceConnectionStatus.module__chartLine___S1JBRm",
  "Pi": "VoiceConnectionStatus.module__chartPoint___S1JBRm",
  "Hh": "VoiceConnectionStatus.module__textGreen___S1JBRm",
  "NV": "VoiceConnectionStatus.module__textBackgroundModifierHover___S1JBRm",
  "Bx": "VoiceConnectionStatus.module__iconSmall___S1JBRm",
  "Kt": "VoiceConnectionStatus.module__deviceIcon___S1JBRm",
  "hz": "VoiceConnectionStatus.module__lockIcon___S1JBRm",
  "Gy": "VoiceConnectionStatus.module__nsModalContent___S1JBRm",
  "uU": "VoiceConnectionStatus.module__nsOptions___S1JBRm",
};

module.exports = exports;
